<nz-layout class="_container">
    <nz-sider nzTheme="light">
        <ul nz-menu nzMode="inline" nzTheme="light">
            <li nz-menu-group nzTitle="S3 Utilities">
                <ul>
                    <li nz-menu-item nzMatchRouter>
                        <a routerLink="s3-explorer">
                            <nz-icon nzType="file" />
                            <span>S3 Explorer</span>
                        </a>
                    </li>
                    <li nz-menu-item nzMatchRouter>
                        <a routerLink="s3-buckets">
                            <nz-icon nzType="cloud-server" nzTheme="outline" />
                            <span>S3 Buckets</span>
                        </a>
                    </li>
                </ul>
            </li>
            <li nz-menu-group nzTitle="EC2 Utilities">
                <ul>
                    
                </ul>
            </li>
        </ul>
    </nz-sider>
    <nz-content>
        <router-outlet />
    </nz-content>
</nz-layout>